module.exports = __webpack_public_path__ + "static/media/astro_public_sector.737fbfe3.png";